import React from 'react'

/**
  * @class Basics
  * Show basics
*/

class BasicLink extends React.Component {

  /*constructor(props) {
    super(props);
  }*/

  render() {
    this.current = (this.props.currentBasicDetail === this.props.basicDetailKey) ? 'current' : '';
    /*console.log(this.props)
    if (this.props.match && this.props.match.params && this.props.match.param.id ) {
      console.log("toto")
      //if (this.props.basicRoute === "/" + this.props.match.params.id) this.current = 'current'
    }*/
    return <li onClick={() => this.props.setBasicDetail(this.props.basicDetailKey)} >
      <a className={this.current}>{ this.props.name }</a>
    </li>
  }
}

export default BasicLink




// WEBPACK FOOTER //
// ./src/components/Basics/BasicLink.jsx